import { useState } from "react";
import Navbar from "./Navbar";
import FAQ from "./FAQs";
import { faqsFans } from "./FAQs_QandAOnly";
import Footer from "./Footer";
import supportService from "../services/support";
import toast from "react-hot-toast";


const COUNTRY_CODES = [
  { code: "+1", country: "US", name: "United States", digits: [10] },
  { code: "+1", country: "CA", name: "Canada", digits: [10] },
  { code: "+44", country: "GB", name: "United Kingdom", digits: [10] },
  { code: "+92", country: "PK", name: "Pakistan", digits: [10] },
  { code: "+91", country: "IN", name: "India", digits: [10] },
  { code: "+61", country: "AU", name: "Australia", digits: [9] },
  { code: "+971", country: "AE", name: "UAE", digits: [9] },
  { code: "+966", country: "SA", name: "Saudi Arabia", digits: [9] },
  { code: "+974", country: "QA", name: "Qatar", digits: [8] },
  { code: "+965", country: "KW", name: "Kuwait", digits: [8] },
  { code: "+968", country: "OM", name: "Oman", digits: [8] },
  { code: "+973", country: "BH", name: "Bahrain", digits: [8] },
  { code: "+49", country: "DE", name: "Germany", digits: [10, 11] },
  { code: "+33", country: "FR", name: "France", digits: [9] },
  { code: "+39", country: "IT", name: "Italy", digits: [9, 10] },
  { code: "+34", country: "ES", name: "Spain", digits: [9] },
  { code: "+31", country: "NL", name: "Netherlands", digits: [9] },
  { code: "+32", country: "BE", name: "Belgium", digits: [9] },
  { code: "+41", country: "CH", name: "Switzerland", digits: [9] },
  { code: "+43", country: "AT", name: "Austria", digits: [10, 11] },
  { code: "+46", country: "SE", name: "Sweden", digits: [9] },
  { code: "+47", country: "NO", name: "Norway", digits: [8] },
  { code: "+45", country: "DK", name: "Denmark", digits: [8] },
  { code: "+358", country: "FI", name: "Finland", digits: [9] },
  { code: "+48", country: "PL", name: "Poland", digits: [9] },
  { code: "+7", country: "RU", name: "Russia", digits: [10] },
  { code: "+380", country: "UA", name: "Ukraine", digits: [9] },
  { code: "+90", country: "TR", name: "Turkey", digits: [10] },
  { code: "+20", country: "EG", name: "Egypt", digits: [10] },
  { code: "+27", country: "ZA", name: "South Africa", digits: [9] },
  { code: "+234", country: "NG", name: "Nigeria", digits: [10] },
  { code: "+254", country: "KE", name: "Kenya", digits: [9] },
  { code: "+212", country: "MA", name: "Morocco", digits: [9] },
  { code: "+216", country: "TN", name: "Tunisia", digits: [8] },
  { code: "+213", country: "DZ", name: "Algeria", digits: [9] },
  { code: "+880", country: "BD", name: "Bangladesh", digits: [10] },
  { code: "+94", country: "LK", name: "Sri Lanka", digits: [9] },
  { code: "+977", country: "NP", name: "Nepal", digits: [10] },
  { code: "+95", country: "MM", name: "Myanmar", digits: [8, 9] },
  { code: "+66", country: "TH", name: "Thailand", digits: [9] },
  { code: "+60", country: "MY", name: "Malaysia", digits: [9, 10] },
  { code: "+65", country: "SG", name: "Singapore", digits: [8] },
  { code: "+62", country: "ID", name: "Indonesia", digits: [9, 10, 11] },
  { code: "+63", country: "PH", name: "Philippines", digits: [10] },
  { code: "+84", country: "VN", name: "Vietnam", digits: [9] },
  { code: "+86", country: "CN", name: "China", digits: [11] },
  { code: "+81", country: "JP", name: "Japan", digits: [10, 11] },
  { code: "+82", country: "KR", name: "South Korea", digits: [9, 10] },
  { code: "+55", country: "BR", name: "Brazil", digits: [10, 11] },
  { code: "+54", country: "AR", name: "Argentina", digits: [10] },
  { code: "+52", country: "MX", name: "Mexico", digits: [10] },
  { code: "+56", country: "CL", name: "Chile", digits: [9] },
  { code: "+57", country: "CO", name: "Colombia", digits: [10] },
  { code: "+51", country: "PE", name: "Peru", digits: [9] },
  { code: "+58", country: "VE", name: "Venezuela", digits: [10] },
  { code: "+593", country: "EC", name: "Ecuador", digits: [9] },
  { code: "+64", country: "NZ", name: "New Zealand", digits: [8, 9] },
];

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const validateForm = (formData, countryCode) => {
  const errors = {};

  if (!formData.firstName.trim()) errors.firstName = "First name is required.";
  else if (formData.firstName.trim().length < 2)
    errors.firstName = "First name must be at least 2 characters.";

  if (!formData.lastName.trim()) errors.lastName = "Last name is required.";
  else if (formData.lastName.trim().length < 2)
    errors.lastName = "Last name must be at least 2 characters.";

  if (!formData.email.trim()) errors.email = "Email is required.";
  else if (!EMAIL_REGEX.test(formData.email.trim()))
    errors.email = "Please enter a valid email address.";

  if (formData.phone.trim()) {
    const digits = formData.phone.replace(/\D/g, "");
    const selected = COUNTRY_CODES.find(
      (c) => c.code === countryCode.code && c.country === countryCode.country,
    );
    if (selected && !selected.digits.includes(digits.length)) {
      errors.phone = `${selected.name} (${selected.code}) numbers must be ${selected.digits.join(" or ")} digits.`;
    } else if (!selected && (digits.length < 6 || digits.length > 15)) {
      errors.phone = "Phone number must be between 6 and 15 digits.";
    }
  }

  if (!formData.message.trim()) errors.message = "Message is required.";
  else if (formData.message.trim().length < 10)
    errors.message = "Message must be at least 10 characters.";

  return errors;
};

const FieldError = ({ msg }) =>
  msg ? (
    <p
      className="text-red-400 text-xs mt-1 ml-1"
      style={{ fontFamily: "'Inter', sans-serif" }}
    >
      {msg}
    </p>
  ) : null;


const ContactUs = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
  });

  const [countryCode, setCountryCode] = useState(
    COUNTRY_CODES.find((c) => c.country === "PK"),
  );

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  const handleChange = (e) => {
    const updated = { ...formData, [e.target.name]: e.target.value };
    setFormData(updated);
    if (touched[e.target.name]) {
      const newErrors = validateForm(updated, countryCode);
      setErrors((prev) => ({
        ...prev,
        [e.target.name]: newErrors[e.target.name],
      }));
    }
  };

  const handleBlur = (e) => {
    setTouched((prev) => ({ ...prev, [e.target.name]: true }));
    const newErrors = validateForm(formData, countryCode);
    setErrors((prev) => ({
      ...prev,
      [e.target.name]: newErrors[e.target.name],
    }));
  };

  const handleCountryChange = (e) => {
    const [code, country] = e.target.value.split("|");
    const selected = COUNTRY_CODES.find(
      (c) => c.code === code && c.country === country,
    );
    setCountryCode(selected);
    if (touched.phone) {
      const newErrors = validateForm(formData, selected);
      setErrors((prev) => ({ ...prev, phone: newErrors.phone }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setTouched({
      firstName: true,
      lastName: true,
      email: true,
      phone: true,
      message: true,
    });
    const newErrors = validateForm(formData, countryCode);
    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    try {
      const res = await supportService.post("feedback/", {
        firstName: formData.firstName,
        lastName: formData.lastName,
        email: formData.email,
        phoneNumber: formData.phone
          ? `${countryCode.code}${formData.phone}`
          : "",
        message: formData.message,
      });

      if (res.data.success) {
        toast.success("Message sent successfully!");
        setFormData({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          message: "",
        });
        setErrors({});
        setTouched({});
      }
    } catch (error) {
      console.error("Error submitting feedback:", error);
      toast.error("Failed to send message. Please try again.");
    }
  };

  const inputClass = (field) =>
    `w-full bg-[#111111] border ${
      errors[field] && touched[field] ? "border-red-500" : "border-[#2a2a2a]"
    } text-white placeholder-gray-500 rounded-xl px-5 xl:px-4 py-4 xl:py-3 text-base xl:text-sm outline-none focus:border-[#444] transition-colors`;

  return (
    <>
      <Navbar />

      <section className="bg-black w-full px-24 xl:px-20 lg:px-16 md:px-8 sm:px-6 py-20 xl:py-16 lg:py-12 sm:py-10 mt-10">
        <div className="flex flex-row sm:flex-col gap-20 xl:gap-14 lg:gap-12 sm:gap-10">
          {/* ── LEFT COLUMN ── */}
          <div className="w-[38%] xl:w-[40%] lg:w-[42%] sm:w-full flex-shrink-0 flex flex-col">
            <p
              className="text-white text-xl xl:text-lg lg:text-base font-semibold mb-3 tracking-wide"
              style={{ fontFamily: "'Segoe UI', sans-serif" }}
            >
              Contact Us
            </p>
            <h1
              className="text-white text-5xl xl:text-4xl lg:text-3xl sm:text-2xl font-semibold mb-5 xl:mb-4 leading-tight capitalize"
              style={{ fontFamily: "Norwester", letterSpacing: "0.01em" }}
            >
              Get in Touch
            </h1>
            <p
              className="text-gray-300 text-lg xl:text-base lg:text-sm leading-relaxed mb-8 xl:mb-6 sm:mb-5"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              We're here to help! Whether you have a question about our
              services, need assistance with your account or want to provide
              feedback.
            </p>

            <div className="space-y-4 xl:space-y-3 mb-8 xl:mb-6 sm:mb-5">
              <div className="flex items-center gap-4 xl:gap-3">
                <div className="w-11 h-11 xl:w-9 xl:h-9 rounded-full bg-[#1a1a1a] border border-[#2a2a2a] flex items-center justify-center flex-shrink-0">
                  <svg
                    className="w-5 h-5 xl:w-4 xl:h-4 text-white"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={1.8}
                      d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                    />
                  </svg>
                </div>
                <p
                  className="text-white text-base xl:text-sm break-all"
                  style={{ fontFamily: "'Inter', sans-serif" }}
                >
                  <a
                    onClick={(e) => {
                      e.preventDefault();
                      window.open(
                        "https://mail.google.com/mail/?view=cm&fs=1&to=contact@vupop.io",
                        "_blank",
                      );
                    }}
                    className="hover:text-gray-300 cursor-pointer"
                  >
                    contact@vupop.io
                  </a>
                </p>
              </div>
            </div>

            <hr className="border-[#2a2a2a] mb-6 xl:mb-5" />

            <div>
              <p
                className="text-white text-base xl:text-sm mb-4"
                style={{ fontFamily: "'Inter', sans-serif" }}
              >
                For inquiries or support, connect with us on our social
                platforms
              </p>
              <div className="flex items-center gap-3">
                <a
                  href="https://www.instagram.com/vupop.io/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-11 h-11 xl:w-9 xl:h-9 rounded-full bg-[#1a1a1a] border border-[#2a2a2a] flex items-center justify-center hover:bg-[#2a2a2a] transition-colors"
                >
                  <svg
                    className="w-5 h-5 xl:w-4 xl:h-4 text-white"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                  </svg>
                </a>
                <a
                  href="https://www.facebook.com/p/Vupop-61551859059469/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-11 h-11 xl:w-9 xl:h-9 rounded-full bg-[#1a1a1a] border border-[#2a2a2a] flex items-center justify-center hover:bg-[#2a2a2a] transition-colors"
                >
                  <svg
                    className="w-5 h-5 xl:w-4 xl:h-4 text-white"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                  </svg>
                </a>
                <a
                  href="https://www.linkedin.com/company/vupop/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-11 h-11 xl:w-9 xl:h-9 rounded-full bg-[#1a1a1a] border border-[#2a2a2a] flex items-center justify-center hover:bg-[#2a2a2a] transition-colors"
                >
                  <svg
                    className="w-5 h-5 xl:w-4 xl:h-4 text-white"
                    fill="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z" />
                  </svg>
                </a>
              </div>
            </div>
          </div>

          {/* ── RIGHT COLUMN: FORM ── */}
          <div className="flex-1 sm:w-full min-w-0">
            <form
              onSubmit={handleSubmit}
              noValidate
              className="flex flex-col gap-4 xl:gap-3"
            >
              {/* First Name + Last Name */}
              <div className="flex flex-row sm:flex-col gap-4 xl:gap-3">
                <div className="w-full">
                  <input
                    type="text"
                    name="firstName"
                    placeholder="First Name *"
                    value={formData.firstName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={inputClass("firstName")}
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  />
                  <FieldError msg={touched.firstName && errors.firstName} />
                </div>
                <div className="w-full">
                  <input
                    type="text"
                    name="lastName"
                    placeholder="Last Name *"
                    value={formData.lastName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={inputClass("lastName")}
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  />
                  <FieldError msg={touched.lastName && errors.lastName} />
                </div>
              </div>

              {/* Email */}
              <div>
                <input
                  type="email"
                  name="email"
                  placeholder="Email *"
                  value={formData.email}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  className={inputClass("email")}
                  style={{ fontFamily: "'Inter', sans-serif" }}
                />
                <FieldError msg={touched.email && errors.email} />
              </div>

             
              <div>
                <div className="flex gap-2">
                
                  <select
                    value={`${countryCode.code}|${countryCode.country}`}
                    onChange={handleCountryChange}
                    className="bg-[#111111] border border-[#2a2a2a] text-gray-500 rounded-xl px-2 py-4 xl:py-3 text-sm outline-none focus:border-[#444] transition-colors flex-shrink-0 w-24 sm:w-20 cursor-pointer"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    {COUNTRY_CODES.map((c) => (
                      <option
                        key={`${c.code}-${c.country}`}
                        value={`${c.code}|${c.country}`}
                        style={{ backgroundColor: "#111111", color: "white" }}
                      >
                        {c.country} {c.code}
                      </option>
                    ))}
                  </select>

                  {/* Phone number input */}
                  <input
                    type="tel"
                    name="phone"
                    placeholder={`Phone Number (Optional)`}
                    value={formData.phone}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={`flex-1 min-w-0 bg-[#111111] border ${
                      errors.phone && touched.phone
                        ? "border-red-500"
                        : "border-[#2a2a2a]"
                    } text-white placeholder-gray-500 rounded-xl px-3 sm:px-2 py-4 xl:py-3 text-sm outline-none focus:border-[#444] transition-colors`}
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  />
                </div>
                <FieldError msg={touched.phone && errors.phone} />
              </div>

              {/* Message */}
              <div>
                <textarea
                  name="message"
                  placeholder="Message *"
                  value={formData.message}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  rows={6}
                  className={`${inputClass("message")} resize-none`}
                  style={{ fontFamily: "'Inter', sans-serif" }}
                />
                <FieldError msg={touched.message && errors.message} />
              </div>

              {/* Submit */}
              <button
                type="submit"
                className="w-full bg-[#FFF528] hover:bg-yellow-500 active:bg-yellow-400 transition-colors text-black text-lg xl:text-base sm:text-sm uppercase tracking-widest py-4 xl:py-3 rounded-xl font-semibold"
                style={{ fontFamily: "Norwester" }}
              >
                Submit
              </button>
            </form>
          </div>
        </div>
      </section>

      <FAQ questions={faqsFans} />
      <Footer />
    </>
  );
};

export default ContactUs;
